export default {
	root: {
		padding: '8px 8px'
	}
};
